export const chorePageTranslateEs = {
    LIST_CHORES:{
        ADD_NEW_CHORE_BUTTON: "Agregar nueva misión",
        NOT_CHORES_TEXT: "No hay misiones aquí todavía. ¡Comienza agregando una nueva!",
        BACK_BUTTON:"Misión"
    },
}